import {useCustomizationConfig} from '@goschool/model'

export function Welcome() {
  const {siteIcon} = useCustomizationConfig()
  return <img src={siteIcon} alt="Link" style={{width: 'auto', maxHeight: '200px'}}/>
}
